module.exports = __webpack_public_path__ + "img/save-money.a367183b.jpg";